import { axiosInstance } from "./BaseService" 

export async function getSettings() {
  try {
    const response = await axiosInstance.get('/users/me');
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function updateSettings(users) {
  try {
    const response = await axiosInstance.patch('/users', users);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function resetPassword(password) {
  try {
    const response = await axiosInstance.patch('/users/reset/password', { password });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function deactivateUserInTenantApp(userId) {
  try {
    const response = await axiosInstance.patch('/users/deactivate', { userId });
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function fetchUserCtx() {
  try {
    const response = await axiosInstance.get('/users/ctx');
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function fetchUsersInformation() {
  try {
    const response = await axiosInstance.get('/users/details');
    return response.data;
  } catch (err) {
    throw err;
  }
}

export async function registerUserInTenantApp(payload) {
  try {
    const response = await axiosInstance.post('/users/register', payload);
    return response.data;
  } catch (err) {
    throw err;
  }
}